<template>
  <div class="w-full">
    <FieldTitle :model="model" :id="id" />
  </div>
</template>

<script>
import FieldTitle from '@/views/components/schema/common/FieldTitle.vue';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  components: {
    FieldTitle,
  },
  data() {
    return {
      id: this.$uuid(),
    };
  },
};
</script>
